import { sumBy } from 'lodash';
import { formatSharePct } from '../../../../utils/campaigns';

/**
 * Column contract for the Transactions V2 "With Events" Creatives/Publishers
 * CSVs (#11653).
 *
 * Kept in step with the V1 helpers in `campaigndetails/utils` — identical
 * headers and ordering for every column both paths can supply, so the file a
 * customer receives does not depend on which report backs their campaign. The
 * trailing column differs only where the data does: V1 alone carries a target
 * URL, V2 alone carries publisher media.
 */

// Denominators span every row in the export, not the donut's Top-N slice.
const shareTotals = (rows) => ({
  impressions: sumBy(rows, (r) => r.impressions || 0),
  transactions: sumBy(rows, (r) => r.transactions || 0),
});

export const formatCreativesExport = (creatives) => {
  const rows = creatives || [];
  const totals = shareTotals(rows);

  return rows.map((item) => ({
    'Creative ID': item.creativeId,
    // Passed through verbatim: the backend sets name = creativeId when its DSP
    // creative lookup misses, and masking that here would only hide it.
    Name: item.name,
    Impressions: item.impressions || 0,
    'Share of Impressions': formatSharePct(item.impressions, totals.impressions),
    Transactions: item.transactions || 0,
    'Share of Transactions': formatSharePct(item.transactions, totals.transactions),
    'Creative URL': item.media,
  }));
};

export const formatPublishersExport = (publishers) => {
  const rows = publishers || [];
  const totals = shareTotals(rows);

  return rows.map((item) => ({
    Publisher: item.name,
    Impressions: item.impressions || 0,
    'Share of Impressions': formatSharePct(item.impressions, totals.impressions),
    Transactions: item.transactions || 0,
    'Share of Transactions': formatSharePct(item.transactions, totals.transactions),
    // Resolved into every publishersMap branch already, just never exported.
    'Media URL': item.media,
  }));
};
